// extracted by mini-css-extract-plugin
export default {"controlsContainer":"ProductCardSlider-module__controlsContainer-lT65ZJ","controlButton":"ProductCardSlider-module__controlButton-s3nygk"};